import { Box, Fab } from '@mui/material';
import { useMatch, useNavigate } from 'react-router-dom';
import { ViewOnlyContext } from '../context';
import EventGroupForm from 'src/components/EventGroupForm';
import EventGroupHeader from 'src/components/EventGroupHeader';
import ScrollableLayout from 'src/layouts/ScrollableLayout';
import { CREATE_EVENT_ROUTE } from '../constants';
import AddIcon from '@mui/icons-material/Add';

interface Props {
    viewOnly?: boolean;
}

export default function EventGroupScreen(props: Props) {
    const viewOnly = props.viewOnly || false;
    const navigate = useNavigate();

    const routeMatch = useMatch('/group/:groupId');
    if (!routeMatch) {
        return <p>ERROR: unknown route</p>;
    }

    const { groupId } = routeMatch.params;

    if (!groupId) {
        return <p>ERROR: group id</p>;
    }

    const handleCreateEvent = () => {
        navigate(`${CREATE_EVENT_ROUTE}?groupId=${groupId}`);
    };

    return (
        <ViewOnlyContext.Provider value={viewOnly}>
            <ScrollableLayout>
                <Box sx={{ minWidth: 0, width: '100%', maxWidth: { xs: '100%', sm: 400 }, mt: 3, mb: 3, px: 2, boxSizing: 'border-box' }}>
                    <EventGroupHeader groupId={groupId} />
                    <EventGroupForm groupId={groupId} />
                </Box>
                {!viewOnly && (
                    <Fab
                        color="primary"
                        aria-label="create event"
                        sx={{
                            position: 'fixed',
                            bottom: 32,
                            right: 32,
                        }}
                        onClick={handleCreateEvent}
                    >
                        <AddIcon />
                    </Fab>
                )}
            </ScrollableLayout>
        </ViewOnlyContext.Provider>
    );
}
